<template>
  <div class="layout">
    <div class="sidebar-filters">
      <div>
        <label>Item Name:</label>
        <input v-model="itemNameFilter" placeholder="Filter Item Name" type="text" />
      </div>
      <label>Status Filter:</label>
      <div class="checkbox-group">
        <label v-for="option in statusOptions" :key="option" class="checkbox-label">
          <input
            type="checkbox"
            :value="option"
            v-model="statusFilter"
          />
          {{ option }}
        </label>
      </div>
      <button @click="restoreDefaults" class="restore-btn">Restore Default Filters</button>
    </div>

    <div class="table-container">
      <table>
        <thead>
          <tr>
            <th>Item Name</th>
            <th>To be machined</th>
            <th>Priority</th>
            <th>Negative Qty Note</th>
            <th>Purchase Tag</th>
            <th>Godown Info</th>
            <th>Status</th>
            <th>Negative Qty FGs</th>
          </tr>
        </thead>
        <tbody>
          <tr
            v-for="(row, idx) in filteredRows"
            :key="idx"
            :class="{ 'negative-note-row': row.K && row.K.toLowerCase().includes('negative') }"
          >
            <td>{{ row.A }}</td>
            <td>{{ row.B }}</td>
            <td>{{ row.C }}</td>
            <td>{{ row.K }}</td>
            <td>{{ row.L }}</td>
            <td style="white-space: pre-wrap; text-align: left;">{{ row.M }}</td>
            <td>{{ row.O }}</td>
            <td style="white-space: pre-wrap; text-align: left;">{{ row.P }}</td>
          </tr>
        </tbody>
      </table>
    </div>
  </div>
</template>

<script setup>
import { ref, onMounted, computed, watch } from 'vue';

const backendUrl = process.env.VUE_APP_BACKEND_URL;

const rowData = ref([]);
const itemNameFilter = ref('');
const statusFilter = ref([]);
const statusOptions = ['Send for Machining', 'Follow Up'];
const FILTERS_KEY = 'machReqFilters';
const filteredRows = computed(() =>
  rowData.value.filter(row =>
    (!itemNameFilter.value || String(row.A).toLowerCase().includes(itemNameFilter.value.toLowerCase())) &&
    (
      !statusFilter.value.length ||
      statusFilter.value.some(opt =>
        row.O && row.O.toLowerCase().includes(opt.toLowerCase())
      )
    )
  )
);

// Restore default filters function
function restoreDefaults() {
  itemNameFilter.value = '';
  statusFilter.value = [];
  localStorage.setItem(
    FILTERS_KEY,
    JSON.stringify({
      itemNameFilter: itemNameFilter.value,
      statusFilter: statusFilter.value,
    })
  );
}

onMounted(async () => {
  const saved = localStorage.getItem(FILTERS_KEY);
  if (saved) {
    const filters = JSON.parse(saved);
    itemNameFilter.value = filters.itemNameFilter ?? '';
    statusFilter.value = filters.statusFilter ?? [];
  }
  const response = await fetch(`${backendUrl}/excel/mach-req`);
  const data = await response.json();
  rowData.value = (data.items || []).map(row => ({
    A: row[0], B: row[1], C: row[2], K: row[10], L: row[11],
    M: row[12], O: row[14], P: row[15]
  }));
});

// Watch and save filters to localStorage
watch([itemNameFilter, statusFilter], () => {
  localStorage.setItem(
    FILTERS_KEY,
    JSON.stringify({
      itemNameFilter: itemNameFilter.value,
      statusFilter: statusFilter.value,
    })
  );
}, { deep: true });

</script>

<style>
.layout {
  display: flex;
  gap: 2em;
}
.sidebar-filters {
  min-width: 220px;
  background: #f9fafb;
  padding: 1em;
  border-radius: 8px;
  margin-bottom: 1em;
  height: fit-content;
}
.sidebar-filters > div {
  margin-bottom: 1em;
}
.checkbox-group {
  display: flex;
  flex-direction: column;
  gap: 0.3em;
}
.checkbox-label {
  display: flex;
  align-items: center;
  gap: 0.5em;
  font-weight: normal;
}
.table-container {
  flex: 1;
  overflow-x: auto;
  margin: 2em 0;
}
table {
  border-collapse: collapse;
  width: 100%;
  font-size: 0.85rem;
}
th, td {
  border: 1px solid #ccc;
  padding: 0.5em 0.75em;
  text-align: left;
}
th {
  background: #f4f4f4;
}
.negative-note-row {
  color: #d90429 !important;
}
.restore-btn {
  margin-top: 1em;
  padding: 0.5em 1em;
  background: #3182ce;
  color: #fff;
  border: none;
  border-radius: 6px;
  cursor: pointer;
  font-weight: 600;
  transition: background 0.2s;
}
.restore-btn:hover {
  background: #225ea8;
}
</style>